import { Form, withFormik } from "formik";
import { useTranslation, withTranslation } from "react-i18next";
import { FormRow } from "../Form/Form";
import { Button } from "primereact/button";
import { Steps } from "primereact/steps";
import { PrimeCheckbox, PrimeDatePicker, PrimeMultiSelect, PrimeRadioGroup, PrimeSelect, PrimeTable, PrimeTextArea } from "../PrimeForm/Form";
import InputNumberPrime from "../PrimeComponents/InputNumberPrime";
import DataTablePrime from "../PrimeComponents/DataTablePrime";
import MultiSelectPrime from "../PrimeComponents/MultiSelectPrime";
import ButtonPrime from "../PrimeComponents/ButtonPrime";

const FormComponent = ({ dialogState, errors, touched, setSubmitting, values,unit, ...otherProps }) => {
    const { t, i18n } = useTranslation();
    const allowEditAGViewer = (rowData) => {
        const isSelected = values?.sensores_selected?.find((e) => e.key === rowData.key);
        return rowData.soil && isSelected;
    };
    const numberEditor = (options) => {
        return <InputNumberPrime className="tableEdit" min={0} value={options.value} onChange={(e) => options.editorCallback(e.value)} />;
    };
    const depthTemplate = (rowData) => {
        if(rowData.depth){
            return `${rowData.depth} ${unit}`;
        }
    };
    return (
        <div id="mktFormContent">
            {!dialogState.hideStepper && (
                <Steps
                    model={dialogState.steps}
                    activeIndex={dialogState.activeStep}
                    readOnly={false}
                    className="mkt-stepper"
                    onSelect={(e) => {
                    // only change step if i want to change some form confgi
                        const lastStep = dialogState.steps.length - 1;
                        const penultimateStep = lastStep - 1;
                        const selectedStep = e.index;
                        if (selectedStep !== penultimateStep) return;
                        if (dialogState.activeStep !== lastStep) return;
                        otherProps.setDialogState(p => ({ ...p, activeStep: e.index }));
                    }}
                />
            )}

            <Form id="mktForm" >
                <div className="col-12 col-md-12">
                    {Boolean(dialogState.steps?.[dialogState.activeStep].inputs?.length) && (
                        dialogState.steps[dialogState.activeStep].inputs.map(input => {
                        // edit: if input is in edit mode, by default all inputs are editable
                        // allowNoEdit: not editable only if another criteria is met
                            const edit = input.edit === false || (dialogState?.data?.distribuidor_id && input?.allowNoEdit) ? false : true;
                            let selected;
                            switch (input.component) {
                                case "divider":
                                    return <div>
                                        <span className="titulo-parametro text-center">{input.label}</span>
                                        <hr className="titulo-parametro-hr" />
                                    </div>;
                                case "select":
                                // it shows a text component:
                                // 1. when 'triggeredBy' has a option selected
                                // 2. when 'triggeredBy' is not configured
                                    if(!input.triggeredBy || (input.triggeredBy && values[input.triggeredBy])){
                                        return <PrimeSelect
                                            edit={edit}
                                            nombre={input.label}
                                            dataValue={values?.[input.campo]}
                                            campo={input.campo}
                                            options={input.options ?? dialogState.data[input.optionsName]}
                                            optionLabel={input.optionLabel ?? "label"}
                                            optionKey={input.optionKey ?? "value"}
                                            placeholder={input.label}
                                            validate={input.validation}
                                            error={touched?.[input.campo] && errors?.[input.campo] && t(errors?.[input.campo])}
                                            onChange={(updatedValue) =>{
                                                if (input.onChange){
                                                    input.onChange(updatedValue, { dialogState, ...otherProps }, input.options ?? dialogState.data[input.optionsName]);
                                                }
                                            }}
                                            optionGroupChildren={input.optionGroupChildren}
                                            optionGroupLabel={input.optionGroupLabel}
                                            showClear={input.showClear}
                                            tooltip={input.tooltip}
                                        />;
                                    }
                                    return null;
                                case "text": {
                                    const useCampo2 = input.useCampo2;
                                    const useCampo1 = !useCampo2;
                                    // it shows a text component:
                                    // 1. when 'triggeredBy' input is equal to 'valueEqualsTo'
                                    // 2. when 'triggeredBy' is not configured
                                    if(!input.triggeredBy || (input.triggeredBy && (values[input.triggeredBy] === input.valueEqualsTo))){
                                        return <FormRow
                                            key={input.campo}
                                            edit={edit}
                                            nombre1={useCampo1 && input.label}
                                            nombre2={useCampo2 && input.label}
                                            dato1={useCampo1 && (values[input.campo] ?? input.value ?? dialogState.data[input.campo])}
                                            dato2={useCampo2 && (values[input.campo] ?? input.value ?? dialogState.data[input.campo])}
                                            campo1={useCampo1 && input.campo}
                                            campo2={useCampo2 && input.campo}
                                            validate1={useCampo1 && input.validation}
                                            validate2={useCampo2 && input.validation}
                                            error1={useCampo1 && touched?.[input.campo] && errors?.[input.campo] && t(errors?.[input.campo])}
                                            error2={useCampo2 && touched?.[input.campo] && errors?.[input.campo2] && t(errors?.[input.campo2])}
                                            eyeForPassword={input.eyeForPassword}
                                            type1={useCampo1 && input.type}
                                            type2={useCampo2 && input.type}
                                        />;
                                    }
                                    return null;
                                }
                                case "date":
                                    return <PrimeDatePicker
                                        edit={edit}
                                        nombre={input.label}
                                        campo={input.campo}
                                        placeholder={input.label}
                                        maxDate={input.maxDate}
                                        minDate={input.minDate}
                                        validate={input.validation}
                                        error={touched?.[input.campo] && errors?.[input.campo] && t(errors?.[input.campo])}
                                        locale={i18n.language}
                                    />;
                                case "info":
                                // it shows an info component:
                                // 1. when 'triggeredBy' is configured from a select component and a option is selected
                                // 2. when 'triggeredBy' is not configured
                                    selected = dialogState.data[input.optionsName]?.find(e => e[input.optionsKey] === values[input.triggeredBy]);
                                    return <div className="row linea-formulario">
                                        {input.triggeredBy ? (
                                            selected && (
                                                input.content(values[input.triggeredBy], selected, { dialogState, ...otherProps })
                                            )
                                        ) : (
                                            input.content(dialogState)
                                        )}
                                    </div>;
                                case "error":
                                    return errors?.[input.errorKey] && <div className="mb-2 col-12 d-block">
                                        <div className="alert alert-warning m-0" role="alert">{t(errors?.[input.errorKey])}</div>
                                    </div>;
                                case "checkbox":
                                    return <PrimeCheckbox
                                        edit={edit}
                                        nombre={input.label}
                                        campo={input.campo}
                                        placeholder={input.label}
                                        validate={input.validation}
                                        error={touched?.[input.campo] && errors?.[input.campo] && t(errors?.[input.campo])}
                                    />;
                                case "radioGroup":
                                    return <PrimeRadioGroup
                                        edit={edit}
                                        radioBtns={input.radioGroup}
                                        nombre={input.label}
                                        campo={input.campo}
                                        placeholder={input.label}
                                        validate={input.validation}
                                        error={touched?.[input.campo] && errors?.[input.campo] && t(errors?.[input.campo])}
                                    />;
                                case "textArea":
                                    return <PrimeTextArea
                                        edit={edit}
                                        nombre={input.label}
                                        campo={input.campo}
                                        placeholder={input.label}
                                        validate={input.validation}
                                        error={touched?.[input.campo] && errors?.[input.campo] && t(errors?.[input.campo])}
                                    />;
                                case "tableAg":
                                    return(
                                        <PrimeTable
                                            t={t}
                                            edit={edit}
                                            nombre={t("node.sensores")}
                                            campo={input.campo}
                                            tableName="tableAgSensors"
                                            selected_campo="sensores_selected"
                                            editMode="row" dataKey="key"
                                            error={errors?.["sensores_selected"] && t(errors?.["sensores_selected"])}
                                            selectionMode="checkbox" fields={[
                                                {field:"port",header:t("node.portsTable.port")},
                                                {field:"sensor_type",header:t("general.type"), body:((r) => dialogState?.data?.sensorTypes?.[r.sensor_type]?.text)},
                                                {field:"depth",header:`${t("forms.profundidad")} [${unit}]`, editor:numberEditor, body:depthTemplate},
                                                {field:"depth",header:null, rowEditor:allowEditAGViewer},
                                            ]}
                                        />);
                                case "tableAgRev":
                                    return <>
                                        {
                                            dialogState.activeStep===3?
                                                <div className="row linea-formulario">
                                                    <div className="col-12 col-md-12 text-md-center">
                                                        <label className='boldie'>{t("node.sensores")}</label>
                                                    </div>
                                                    <div className="mb-2 col-12 col-md-12 d-block d-flex flex-column">
                                                        <DataTablePrime
                                                            t={t}
                                                            tableName="tableAgSensorsRev"
                                                            value={dialogState.data.sensores_selected} fields={[
                                                                {field:"port",header:t("node.portsTable.port")},
                                                                {field:"sensor_type",header:t("general.type"), body:((r) => dialogState?.data?.sensorTypes?.[r.sensor_type]?.text)},
                                                                {field:"depth",header:`${t("forms.profundidad")} [${unit}]`, body:depthTemplate},
                                                            ]}
                                                        />
                                                    </div>
                                                </div>
                                                :null
                                        }
                                    </>;
                                case "multiSelect":
                                    if(!input.triggeredBy || (input.triggeredBy && values[input.triggeredBy])){
                                        return <PrimeMultiSelect
                                            edit={edit}
                                            nombre={input.label}
                                            dataValue={values?.[input.campo]}
                                            errorLbl={input?.errorLbl}
                                            campo={input.campo}
                                            options={input.options ?? dialogState.data[input.optionsName]}
                                            optionLabel={input.optionLabel ?? "label"}
                                            optionKey={input.optionKey ?? "value"}
                                            validate={input.validation}
                                            error={touched?.[input.campo] && errors?.[input.campo] && t(errors?.[input.campo])}
                                            onChange={(updatedValue) =>{
                                                if (input.onChange){
                                                    input.onChange(updatedValue, { dialogState, ...otherProps }, input.options ?? dialogState.data[input.optionsName]);
                                                }
                                            }}
                                            optionGroupChildren={input.optionGroupChildren}
                                            optionGroupLabel={input.optionGroupLabel}
                                            showClear={input.showClear}
                                            t={t}
                                            valuesPrev={input.valuesPrev}
                                        />;
                                    }
                                    return null;
                                case "infoList":
                                    return <>
                                        {
                                            dialogState.activeStep===2 && values?.[input.campo]?.length >0?
                                                <div className="row linea-formulario">
                                                    <div className="col-12 col-md-6 text-md-right">
                                                        <label className='boldie capitalize'>{input.label}</label>
                                                    </div>
                                                    <div className="mb-2 col-12 col-md-6 d-block d-flex flex-column">
                                                        <ul>
                                                            {values?.[input.campo]?.map((data,index) => {
                                                                const option = input?.options?.find(o => o?.[input.optionKey] === data);
                                                                return <li key={`${input?.label}-${index}`}>{option?.[input?.optionLabel]}</li>;
                                                            })}
                                                        </ul>
                                                    </div>
                                                </div>
                                                :null
                                        }
                                    </>;
                                case "buttonValidation":
                                    if(!input.triggeredBy || (input.triggeredBy && values[input.triggeredBy] && !values[input.validationField])){
                                        return(
                                            <>
                                                <div className="col-12 col-md-12 text-md-center">
                                                    <ButtonPrime className="form_validationBtn" type="button" raised label={input.label} icon="pi pi-check" size="small" severity="success" onClick={(e) =>{
                                                        if (input.validation_function){
                                                            input.validation_function({ dialogState, ...otherProps }, values);
                                                        }
                                                    }}
                                                    />
                                                </div>
                                                {errors?.[input.validation_error] ?
                                                    <div className="mt-2 mb-2 col-12 d-block">
                                                        <div className="alert alert-warning m-0" role="alert">{input.label}: {errors[input.validation_error]}</div>
                                                    </div>
                                                    : null}
                                            </>
                                        );
                                    }
                                    return null;
                                default:
                                    return null;
                            }
                        })
                    )}
                    {errors?.unknown && (
                        <div className="mb-2 col-12 d-block">
                            <div className="alert alert-warning m-0" role="alert">{t(errors.unknown)}</div>
                        </div>
                    )}
                    {!dialogState.disableButtons && (
                        <div className='mkt-button mkt-btn-continue mt-4'>
                            <Button
                                label={dialogState.activeStep === dialogState.steps?.length - 1  ? (dialogState.confirmButtonLabel ?? t("sass.conectar")) : t("external.next")}
                                type='submit'
                                onClick={() => setSubmitting(true)}
                            />
                        </div>
                    )}
                </div>
            </Form>
        </div>
    );
};

const FormikForm = withFormik({
    mapPropsToValues: (props) => {
        const activeStep = props.dialogState.activeStep;
        const values = props.dialogState.steps[activeStep].inputs.reduce((res,i) => {
            if (i.campo) res[i.campo] = props.dialogState.data?.[i.campo] ?? null;
            else if (i.campo2) res[i.campo2] = props.dialogState.data?.[i.campo2] ?? null;
            if(i.campo==="sensors" && i.campo2==="sensores_selected"){
                res[i.campo2] = props.dialogState.data?.[i.campo2] ?? null;
            }
            return res;
        }, {});
        return values;
    },
    enableReinitialize: true,
    validate: async (values, props) => {
        // apply custom step validation
        const activeStep = props.dialogState.activeStep;
        const customValidateFunction = props.dialogState.steps[activeStep].validateFunction;
        if(customValidateFunction) {
            return await customValidateFunction(values, props);
        }
    },
    handleSubmit: (values, { props }) => {
        props.connect(values, props);
    },
})(withTranslation()(FormComponent));

export { FormikForm as ActionForm };
